module.exports = __webpack_public_path__ + "img/1.543ff415.png";